<!--用电峰平谷-->
<template>
  <div class="peakAndFlatBody usePowerUnitDiv">
    <div class="topLeftTitleContent">用电峰平谷</div>
    <div class="peakContent bodyBorder">
      <!--图表区域-->
      <div class="peakChart">
        <div class="peakPie">
          <vchart ref='vchartPie'></vchart>
        </div>
        <div class="peakCloun">
          <vchart ref='vchartBar'></vchart>
        </div>
      </div>
      <!--选择table块-->
      <div class="tab-label">
        <div class="tab-label-span" @click="changSelectTab(0)" :style="tabStyle('0')">
          <span>当月</span>
        </div>
        <div class="tab-label-span" @click="changSelectTab(1)" :style="tabStyle('1')">
          <span>上月</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import vchart from '@/components/module/chart/vchart.vue'
  export default {
    components: {
      vchart,
    },
    props: [],
    data () {
      return {
        selectTab: 0, //0今日1昨日2前日
        thisMonthData: [{value: 0,name: '尖'},{value: 0,name: '峰'},{value: 0,name: '平'},{value: 0,name: '谷'}],//当月数据
        lastMonthData: [{value: 0,name: '尖'},{value: 0,name: '峰'},{value: 0,name: '平'},{value: 0,name: '谷'}],//本月数据
        pieOption: {
          tooltip: {
            trigger: 'item',
            formatter: '{b} : {c}',
            show: true,
          },
          // legend: {
          // 	orient: 'vertical',
          // 	icon: "circle",
          // 	left: 'left',
          // 	top: 'center',
          // 	textStyle: {
          // 		color: 'white',
          // 	},
          // 	itemGap: 40,
          // 	padding: [0, 0, 0, 10],
          // 	data: ['尖','峰', '平', '谷']
          // },
          color: ['#e15d68','#f29961','#407fff','#14a89f'],
          series: [{
            type: 'pie',
            radius: ['80%','25%'],
            center: ['60%','50%'],
            label: {
              normal: {
                show: true,
                position: 'inner',
                textStyle: {
                  fontWeight: 100,
                  fontSize: 12
                },
                formatter: '{d}%'
              }
            },
            data: [20,30,40,55],
            emphasis: {
              itemStyle: {
                shadowBlur: 20,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }]
        },
        barOption: {
          tooltip: {
            trigger: 'item',
            formatter: '{b} : {c}',
            show: true,
          },
          xAxis: {
            type: 'category',
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#a0d2ff'
              }
            },
            axisTick: { //y轴刻度线
              show: false
            },
            axisLine: { //y轴
              show: false
            },
            data: ['尖','峰','平','谷']
          },
          yAxis: {
            type: 'value',
            splitLine: {
              lineStyle: {
                color: ['#18205f']
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#a0d2ff'
              }
            },
            axisTick: { //y轴刻度线
              show: false
            },
            axisLine: { //y轴
              show: false
            },
          },
          grid: [{
            bottom: '14%',
            height: 130,
            containLabel: true,
          }],
          series: [{
            data: [20,30,40,55],
            type: 'bar',
            barWidth: 60,
            itemStyle: {
              normal: {//这里是重点
                color: function(params) {
                  var colorList=['#e15d68','#f29961','#407fff','#14a89f'];
                  return colorList[params.dataIndex]
                }
              }
            },
            showBackground: true,
          }]
        },
      }
    },
    created () {},
    mounted () {
      this.initData()
      this.$refs.vchartPie.setData(this.pieOption,true)
      this.$refs.vchartBar.setData(this.barOption,true)
    },
    destroyed () {},
    computed: {
      tabStyle () {
        return index => {
          if(index==this.selectTab) {
            return {
              'background': '#12408a'
            }
          } else {
            return {
              'background': '#11173c'
            }
          }
        }
      },
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
    },
    watch: {
      nowUnit (nv,ov) {

      },
      // selectTab(nv, ov) {
      // 	this.initData()
      // }
    },
    methods: {
      changSelectTab (value) {
        this.selectTab=value;
        switch(value) {
          case 0:
            this.pieOption.series[0].data=this.thisMonthData
            this.barOption.series[0].data=this.thisMonthData
            break;
          case 1:
            this.pieOption.series[0].data=this.lastMonthData
            this.barOption.series[0].data=this.lastMonthData
            break;
        }

      },
      initData () {
        let atListDay="" //月最后一天
        let dataType=""
        var nowdays=new Date();
        var year=nowdays.getFullYear();
        var month=nowdays.getMonth();
        if(month==0) {
          month=12;
          year=year-1;
        }
        if(month<10) {
          month='0'+month;
        }
        var myDate=new Date(year,month,0);
        var endDate=year+'-'+month+'-'+myDate.getDate()
        switch(this.selectTab) {
          case 0:
            dataType="当月"
            atListDay=nowdays.getTime()
            break;
          case 1:
            dataType="上月"
            atListDay=nowdays.getTime()
            break;
        }


        this.$api.powerApi.getqueshengUnitPG(this.nowUnit.id,dataType,atListDay,respon => {
          if(!isempty(respon)) {
            respon.month.forEach((item,index) => {
              this.thisMonthData[index].value=item;
            })
            respon.lastMonth.forEach((item,index) => {
              this.lastMonthData[index].value=item;
            })

            this.thisMonthData.map((item,i) => {
              if(Number(item.value)<0) {
                this.thisMonthData[i].value=0
              }
            });
            this.lastMonthData.map((item,i) => {
              if(Number(item.value)<0) {
                this.lastMonthData[i].value=0
              }
            });
            //当月值
            this.pieOption.series[0].data=this.thisMonthData
            this.barOption.series[0].data=this.thisMonthData

          }
        })
      }
    }
  }
</script>

<style scoped>
  @import url("../../../components/css/usePowerUnit.css");

  .peakAndFlatBody {
    height: 274px;
  }

  .peakAndFlatBody .peakContent {
    height: calc(100% - 31px);
  }

  .peakAndFlatBody .peakChart {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .peakAndFlatBody .peakChart .peakPie {
    width: 40%;
    height: 100%;
  }

  .peakAndFlatBody .peakChart .peakCloun {
    width: 60%;
    height: 100%;
  }

  /*选择块*/

  .peakAndFlatBody .tab-label {
    width: 200px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: relative;
    left: 69%;
    bottom: 99%;
  }

  .peakAndFlatBody .tab-label-span {
    width: 30%;
    height: 65%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #12408A;
    border-radius: 10%;
    font-size: .12rem;
    z-index: 999;
  }

  .peakAndFlatBody .default-chart {
    height: 100%;
  }
</style>